module.exports = __webpack_public_path__ + "img/header-15.66b8b1d.jpeg";